import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  makeStyles,
  Typography,
  DialogTitle,
  DialogContent,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { anularVoucherLiq, cleanComprobanteSeleccionado, devolucionExpMesaEntrada, eliminarTodasLineasComprobante, getTotalLineasComprobante, modificarEmailEfectorComprobante, modificarEstadoComprobante, putLiberarComprobante } from "../../../actions/liquidaciones/liquidaciones";
import { ModalLineasPrestacion } from "./lineasComprobante/lineasPrestacion/ModalLineasPrestacion";
import { LIQUIDACIONES_COMPROBANTES_ESTADOS, TIPO_CONTACTO_EFECTOR } from "../../../utils/constants";
import { ModalLineasInsumos } from "./lineasComprobante/lineasInsumo/ModalLineasInsumos";
import DeleteButtonAbm from "../../compartidos/abms/DeleteButtonAbm";
import { deleteComprobanteMesaEntrada } from "../../../actions/mesaEntrada/mesaEntradaActions";
import { LIQUIDACIONES_GESTION_PERMISOS, MESA_ENTRADA_PERMISOS } from "../../../utils/permisos";
import { ModalAddLine, TIPO_LINEA } from "./lineasComprobante/ModalAddLine";
import { NoEncryption, Print } from "@material-ui/icons";
import { ComprobanteImpresionSolicitudPago } from "./ComprobanteImpresionSolicitudPago";
import { ModalLineasMedicamentos } from "./lineasComprobante/lineasMedicamento/ModalLineasMedicamentos";
import { ModalDocumentacionLiq } from "./lineasComprobante/ModalDocumentacionLiq";
import { validarSoloUnPermiso } from "../../../helpers/permisos";

const useStyles = makeStyles((theme) => ({
  title: {
    marginLeft: theme.spacing(5),
    marginBottom: 10,
    flex: 1,
  },
  linesButtons: {
    minWidth: 230,
    marginBottom: 5
  }
}));

export const ModalAuditarFactura = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { comprobanteSeleccionado = {}, centroCostos } = useSelector(
    (state) => state.liquidaciones
  );

  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [openModalLineasMedicamentos, setOpenModalLineasMedicamentos] = useState(false);
  const [openModalLineasPrestacion, setOpenModalLineasPrestacion] = useState(false);
  const [openModalLineasInsumos, setOpenModalLineasInsumos] = useState(false);
  const [openModalAddLine, setOpenModalAddLine] = useState(false);
  const [openModalDocumentacion, setOpenModalDocumentacion] = useState(false);
  const [openOpcionesSolicitud, setOpenOpcionesSolicitud] = useState(false);
  const [emailEfector, setEmailEfector] = useState(null);
  const [emailValido, setEmailValido] = useState(false);
  const [motivoBaja, setMotivoBaja] = useState({
    active: true,
    text: ""
  });

  const { open, closeModalHandler, formatCurrencyPesos, disabled } = props;


  const tienePermisosAnularVoucher =
    validarSoloUnPermiso(permisosUser,
      LIQUIDACIONES_GESTION_PERMISOS.ANULAR_SOLICITUD_PAGO);

  useEffect(() => {
    if (comprobanteSeleccionado?.idComprobante)
      dispatch(getTotalLineasComprobante(comprobanteSeleccionado?.idComprobante));
  }, [dispatch, comprobanteSeleccionado?.idComprobante]);

  const handleCloseModal = () => {
    closeModalHandler();
    dispatch(cleanComprobanteSeleccionado());
  };

  const handleDelete = (idExpediente) => {
    dispatch(deleteComprobanteMesaEntrada({ idExpediente, motivoBaja: motivoBaja.text }));
    handleCloseModal();
  };

  const handleFinalizarCarga = (retornar) => {
    const nuevoIdEstado = retornar
      ? LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA
      : (comprobanteSeleccionado?.expediente?.idEstado ===
        LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA ||
        comprobanteSeleccionado?.expediente?.idEstado ===
        LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA)
        ? LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION
        : (comprobanteSeleccionado?.expediente?.idEstado ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION ||
          comprobanteSeleccionado?.expediente?.idEstado ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA)
          ? LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO
          : LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA

    dispatch(modificarEstadoComprobante(
      comprobanteSeleccionado?.idComprobante,
      nuevoIdEstado,
      comprobanteSeleccionado?.expediente?.idEstado,
      props.fechaDesde,
      props.fechaHasta,
      props.idEfectorFacturacion
    )
    );
  }

  const handleAnularSolicitudPago = () => {
    dispatch(anularVoucherLiq(
      comprobanteSeleccionado?.relacionVoucherExpediente[0]?.idSolicitudPago,
      props.idEfectorFacturacion,
      props.fechaDesde,
      props.fechaHasta,
      LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA,
      comprobanteSeleccionado?.idComprobante,
    )
    );
  }

  const handleDevolucionMesaEntrada = () => {
    const nuevoIdEstado = LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA

    dispatch(devolucionExpMesaEntrada(
      comprobanteSeleccionado?.idComprobante,
      nuevoIdEstado,
      comprobanteSeleccionado?.expediente?.idEstado,
      props.fechaDesde,
      props.fechaHasta,
      props.idEfectorFacturacion
    )
    );
  }


  useEffect(() => {
    if (comprobanteSeleccionado) {
      if (!comprobanteSeleccionado?.comprobanteContrato?.emailEfector) {
        const contactoFacturacion = comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.efectorContactos
          .find(s => s.idTipoContacto === TIPO_CONTACTO_EFECTOR.FACTURACION && !s.fechaBaja);

        if (contactoFacturacion) {
          validateChangeEmail(contactoFacturacion.email);
        } else {
          const contactoTesoreria = comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.efectorContactos
            .find(s => s.idTipoContacto === TIPO_CONTACTO_EFECTOR.TESORERIA && !s.fechaBaja);

          if (contactoTesoreria)
            validateChangeEmail(contactoTesoreria.email);
        }
      } else {
        validateChangeEmail(comprobanteSeleccionado?.comprobanteContrato?.emailEfector, true);
      }
    }
  }, [comprobanteSeleccionado?.efectorFacturacion?.efectorContactos, comprobanteSeleccionado?.comprobanteContrato?.emailEfector, comprobanteSeleccionado]);

  const validateChangeEmail = (email, validate = false) => {
    // eslint-disable-next-line
    let reg = new RegExp(`[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+`);
    if (reg.test(email) || email?.length === 0) {
      if (validate)
        setEmailValido(true);
      else
        setEmailValido(false);
    } else {
      setEmailValido(false);
    }
    setEmailEfector(email);
  };

  const handleDeleteLineas = (idExpediente) => {
    dispatch(eliminarTodasLineasComprobante(idExpediente));
  };


  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth="md"
      //   maxWidth="lg"
      onClose={handleCloseModal}
    >
      <DialogTitle>
        {openOpcionesSolicitud &&
          <ComprobanteImpresionSolicitudPago
            open={openOpcionesSolicitud}
            comprobante={comprobanteSeleccionado}
            solicitudPago={comprobanteSeleccionado?.relacionVoucherExpediente?.[0]}
            closeModalHandler={() => setOpenOpcionesSolicitud(false)}
          />
        }
        <div style={{ fontSize: 12 }}>
          IdComprobante {comprobanteSeleccionado?.idComprobante}
        </div>
        <div style={{ fontSize: 15 }}>
          {comprobanteSeleccionado?.relacionVoucherExpediente?.[0]?.idSolicitudPago ? (
            <> Solicitud Pago N°: {comprobanteSeleccionado.relacionVoucherExpediente[0].idSolicitudPago}</>
          ) : null}
        </div>
        <div>
          <span style={{ float: 'left' }}>
            Resumen del Comprobante N°: {`${comprobanteSeleccionado?.nroSucursal.toString().padStart((5), '0')}-${comprobanteSeleccionado?.nroFactura.toString().padStart((8), '0')}`}

            {comprobanteSeleccionado?.expediente?.idEstado !==
              LIQUIDACIONES_COMPROBANTES_ESTADOS.ANULADA &&
              comprobanteSeleccionado?.expediente?.idEstado !==
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PAGADA &&
              <DeleteButtonAbm
                handleDelete={() => handleDelete(comprobanteSeleccionado?.idComprobante)}
                permiso={MESA_ENTRADA_PERMISOS.BAJA}
                mensajeEliminacion="¿Desea anular este comprobante?"
                toolTip={'Anular Comprobante'}
                toolTipAligment={'right'}
                motivo={motivoBaja}
                setMotivo={setMotivoBaja}
                validators={[
                  "required",
                  "minStringLength:10",
                  "maxStringLength:100"
                ]}
                errorMessages={[
                  "Debe ingresar un motivo de baja",
                  "El motivo de baja debe tener al menos 10 caracteres",
                  "El motivo de baja no debe tener más de 100 caracteres"
                ]}
              />
            }
          </span>
          {(comprobanteSeleccionado?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA
            || comprobanteSeleccionado?.expediente?.idEstado === LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA
            || comprobanteSeleccionado?.expediente?.idEstado === LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA
            || comprobanteSeleccionado?.expediente?.idEstado === LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA
            || comprobanteSeleccionado?.expediente?.idEstado === LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION
            || comprobanteSeleccionado?.expediente?.idEstado === LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO
            || comprobanteSeleccionado?.expediente?.idEstado === LIQUIDACIONES_COMPROBANTES_ESTADOS.PAGADA)
            &&
            <div>
              <Tooltip
                title={
                  <>
                    <span style={{
                      fontSize: 13,
                    }}>
                      {`${(comprobanteSeleccionado?.expediente?.idEstado ===
                        LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION
                        || comprobanteSeleccionado?.expediente?.idEstado ===
                        LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA
                        || comprobanteSeleccionado?.expediente?.idEstado ===
                        LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA
                        || comprobanteSeleccionado?.expediente?.idEstado ===
                        LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO
                        || comprobanteSeleccionado?.expediente?.idEstado ===
                        LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA)
                        ? "Previsualizar Solicitud de Pago"
                        : "Imprimir Solicitud de Pago"}`}
                    </span>
                  </>
                }
              >
                <IconButton
                  style={{ float: 'right', padding: 0, marginLeft: 15 }}
                  color="inherit"
                  onClick={() => {
                    setOpenOpcionesSolicitud(true);
                  }}
                >
                  <Print />
                </IconButton>
              </Tooltip>
            </div>
          }
          {(comprobanteSeleccionado?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA
            || comprobanteSeleccionado?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION
            || comprobanteSeleccionado?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO) &&
            comprobanteSeleccionado?.comprobantesTomados.length > 0 &&
            <Tooltip
              title={
                <>
                  <span sx={{
                    fontSize: 13,
                  }}>
                    {`Liberar Comprobante`}
                  </span>
                </>
              }
            >
              <IconButton
                style={{ float: 'right', padding: 0 }}
                color="inherit"
                onClick={() => {
                  dispatch(
                    putLiberarComprobante(
                      comprobanteSeleccionado?.comprobantesTomados[0].id,
                      'currentUser',
                      false,
                      null,
                      null,
                      null,
                      handleCloseModal,
                      comprobanteSeleccionado?.idComprobante
                    )
                  );
                }}
              >
                <NoEncryption />
              </IconButton>
            </Tooltip>
          }
        </div>
      </DialogTitle>
      <Typography className={classes.title}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="left"
        >
          <Grid item xs={12} sm={6} md={6}>
            <strong>Efector: </strong>{`${comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.razonSocial}`}
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <strong>Total Comprobante </strong>{`${formatCurrencyPesos(comprobanteSeleccionado?.totalComprobante)}`}
          </Grid>
          <Grid item xs={12} md={6}></Grid>
          <Grid item xs={12} sm={6} md={3}>
            <strong>Total Lineas </strong>{`${formatCurrencyPesos(comprobanteSeleccionado?.totalLineasComprobante)}`}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <strong>Total Débitos </strong>{`${formatCurrencyPesos(comprobanteSeleccionado?.totalDebitosLineasComprobante)}`}
          </Grid>
        </Grid>
      </Typography>
      <DialogContent>
        <Grid
          container
          spacing={1}
          //direction="column"
          //alignItems="flex-start"
          //justify="space-between"
          style={{ marginTop: 5 }}
        // justifyContent="center" 
        >
          <Grid item xs={6} style={{ textAlign: 'left' }}>
            {(comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA ||
              comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION) &&
              <>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.linesButtons}
                  onClick={() => setOpenModalAddLine(true)}
                >
                  Agregar por Nro Orden
                </Button>
                <DeleteButtonAbm
                  handleDelete={() => handleDeleteLineas(comprobanteSeleccionado?.idComprobante)}
                  mensajeEliminacion="¿Desea eliminar todas las líneas de este comprobante?"
                  toolTip={'Eliminar Todas las Líneas'}
                  toolTipAligment={'right'}
                  permiso={null}
                />
              </>
            }
            {openModalAddLine &&
              <ModalAddLine
                open={openModalAddLine}
                tipoLinea={TIPO_LINEA.IdSolicitud}
                // lineaComprobante={lineaComprobante}
                esLineaCodigoLiq={false}
                comprobanteSeleccionado={comprobanteSeleccionado}
                closeModalHandler={() => {
                  setOpenModalAddLine(false);
                }}
              />
            }
          </Grid>
          <Grid item xs={6} style={{ marginTop: 5, textAlign: 'right' }}>
            <ModalLineasPrestacion
              open={openModalLineasPrestacion}
              closeModalHandler={() => {
                setOpenModalLineasPrestacion(false);
              }}
              disabled={disabled}
              formatCurrencyPesos={formatCurrencyPesos}
              comprobanteSeleccionado={comprobanteSeleccionado}
            />
            <Button
              color="primary"
              variant="contained"
              className={classes.linesButtons}
              onClick={() => setOpenModalLineasPrestacion(true)}
            >
              Líneas Prestación
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={1}
          direction="column"
          alignItems="flex-end"
          style={{ marginTop: 5 }}
        //justifyContent="center" 
        >
          <Grid item xs={12}>
            <ModalLineasInsumos
              open={openModalLineasInsumos}
              closeModalHandler={() => {
                setOpenModalLineasInsumos(false);
              }}
              disabled={disabled}
              formatCurrencyPesos={formatCurrencyPesos}
              comprobanteSeleccionado={comprobanteSeleccionado}
            />
            <Button
              color="primary"
              variant="contained"
              className={classes.linesButtons}
              onClick={() => setOpenModalLineasInsumos(true)}
            >
              Líneas Insumos
            </Button>
          </Grid>
          <Grid item xs={12}>
            <ModalLineasMedicamentos
              open={openModalLineasMedicamentos}
              closeModalHandler={() => {
                setOpenModalLineasMedicamentos(false);
              }}
              disabled={disabled}
              centroCostos={centroCostos}
              formatCurrencyPesos={formatCurrencyPesos}
              comprobanteSeleccionado={comprobanteSeleccionado}
            />
            <Button
              color="primary"
              variant="contained"
              sx={classes.linesButtons}
              onClick={() => setOpenModalLineasMedicamentos(true)}
            >
              Líneas Medicamentos
            </Button>
          </Grid>

        </Grid>
        {(comprobanteSeleccionado?.expediente?.idEstado ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION ||
          comprobanteSeleccionado?.expediente?.idEstado ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA ||
          comprobanteSeleccionado?.expediente?.idEstado ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA) &&
          <Grid container /* justify="center" */ style={{ marginTop: 15, marginBottom: 50 }}>
            <Grid item xs={8} sm={6}>
              <TextField
                // margin="normal"
                fullWidth
                // inputProps={{ style: { textTransform: "uppercase" } }}
                label="Email Efector"
                name="emailEfector"
                disabled={disabled}
                value={emailEfector ?? ''}
                error={
                  !comprobanteSeleccionado?.comprobanteContrato?.emailEfector ||
                  comprobanteSeleccionado?.comprobanteContrato?.emailEfector === '' || !emailValido
                }
                helperText={
                  (!comprobanteSeleccionado?.comprobanteContrato?.emailEfector ||
                    comprobanteSeleccionado?.comprobanteContrato?.emailEfector === '')
                    ? "El email es necesario para generar la solicitud de pago"
                    : !emailValido && "El email ingresado no es válido"
                }
                required={true}
                autoComplete="off"
                //autoFocus
                onChange={(e) => {
                  validateChangeEmail(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={4} sm={2}>
              <Button
                color="primary"
                style={{ marginLeft: 15, marginTop: 12 }}
                onClick={() => dispatch(modificarEmailEfectorComprobante(comprobanteSeleccionado?.idComprobante, emailEfector))}
                variant="contained"
                disabled={comprobanteSeleccionado?.comprobanteContrato?.emailEfector === emailEfector}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        }
        <Grid
          container
          spacing={1}
          //direction="column"
          //alignItems="flex-start"
          //justify="space-between"
          style={{ marginTop: 5 }}
        // justifyContent="center" 
        >
          <Grid item xs={12} style={{ textAlign: 'left' }}>
            <>
              <Button
                color="primary"
                variant="contained"
                className={classes.linesButtons}
                onClick={() => setOpenModalDocumentacion(true)}
              >
                Documentación
              </Button>
            </>
            {openModalDocumentacion &&
              <ModalDocumentacionLiq
                open={openModalDocumentacion}
                esLineaCodigoLiq={false}
                comprobanteSeleccionado={comprobanteSeleccionado}
                closeModalHandler={() => {
                  setOpenModalDocumentacion(false);
                }}
                disabled={comprobanteSeleccionado?.expediente?.idEstado ===
                  LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA}
              />
            }
          </Grid>
        </Grid>
        <Grid
          container
          justify="center"
          style={{ marginBottom: 8 }}
        >
          <Grid item xs={6} style={{ textAlign: 'center', marginTop: 15 }}>
            {(comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA ||
              comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION ||
              comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA ||
              comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA) &&
              <Button
                onClick={() => handleFinalizarCarga(false)}
                disabled={
                  (disabled && comprobanteSeleccionado?.expediente?.idEstado !==
                    LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA && comprobanteSeleccionado?.expediente?.idEstado !==
                    LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO) ||
                  (comprobanteSeleccionado?.expediente?.idEstado ===
                    LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION &&
                    (!comprobanteSeleccionado?.comprobanteContrato?.emailEfector ||
                      comprobanteSeleccionado?.comprobanteContrato?.emailEfector === '' || !emailValido))
                }
                variant="contained"
                color="primary"
              >
                {(comprobanteSeleccionado?.expediente?.idEstado ===
                  LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA ||
                  comprobanteSeleccionado?.expediente?.idEstado ===
                  LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA
                )
                  ? 'Finalizar Carga'
                  : comprobanteSeleccionado?.expediente?.idEstado ===
                    LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION ||
                    comprobanteSeleccionado?.expediente?.idEstado ===
                    LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA
                    ? 'Aprobar'
                    : null
                }
              </Button>
            }
            {(comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO) &&
              < Button
                color="primary"
                variant="contained"
                style={{ marginLeft: 15 }}
                onClick={() => handleFinalizarCarga(true)}
              >
                Retornar
              </Button>
            }
            {((comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA) ||
              (comprobanteSeleccionado?.expediente?.idEstado ===
                LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION)) &&
              < Button
                color="primary"
                variant="contained"
                style={{ marginLeft: 15 }}
                onClick={() => handleDevolucionMesaEntrada()}
              >
                Devolucíon Mesa Entrada
              </Button>
            }
            {(comprobanteSeleccionado?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA) &&
              tienePermisosAnularVoucher &&
              < Button
                color="primary"
                variant="contained"
                style={{ marginLeft: 15 }}
                onClick={() => handleAnularSolicitudPago()}
              >
                Anular Solicitud de Pago
              </Button>
            }
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog >
  );
};
